import React from 'react'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import styles from './SaveTemplate.module.scss'

export const SaveTemplate = () => (
  <div className={styles.save}>
    <MessageAlert
      className={styles.alert}
      message={t`You have successfully created new job.`}
      variant="success"
      isInitialised
    />
    <h3 className={styles.title}>
      <span>{t`Would you like to save this new job as a`}</span>
      <strong className={styles.bold}>{t`template`}</strong>?
    </h3>
    <p
      className={styles.text}
    >{t`A job template lets you save information that you can reuse in future recruitments. If you are unsure, you can always save it as a template later from the job page.`}</p>
  </div>
)
